<template>
  <Grid class="grid-nogutter">
    <Col12 class="md:col-4 md:pr-3">
      <div class="flex h-full">
        <template v-if="$slots.customTitle">
          <slot name="customTitle" />
        </template>

        <template v-else>
          <div class="align-self-center flex align-items-center w-full" style="min-height: 40px">
            <h2 id="table-title" class="font-semibold">{{ title }}</h2>
          </div>
        </template>
      </div>
    </Col12>

    <Col12 class="md:col-2 md:pr-3 pt-3 md:pt-0" v-if="$slots.tableActions">
      <div class="flex h-full">
        <div class="align-self-center flex align-items-center">
          <slot name="tableActions" />
        </div>
      </div>
    </Col12>

    <Col12
      class="md:col-6 pt-3 md:pt-0"
      :class="{ 'md:col-8': !$slots.tableActions }"
      v-if="$slots.buttonActions"
    >
      <div class="flex md:justify-content-end h-full w-full">
        <div class="align-self-center flex align-items-center w-full">
          <slot name="buttonActions" />
        </div>
      </div>
    </Col12>
  </Grid>
</template>

<script setup lang="ts">
import { Col12 } from '../columns';
import { Grid } from '../grids';

// Define options
defineOptions({
  name: 'TableHeader',
});

// Define props
defineProps({
  title: {
    type: String,
  },
});
</script>
